import "./EditProduct.scss"
import React from "react"
import { observer } from "mobx-react"
import { Link, Redirect } from "react-router-dom"
import { AppHeader, AppPanel, Button, Icon } from "../../lib"
import { productStore } from "../../stores"

const EditProduct = ({ match }) => {
  if (!productStore.products.size) {
    return null
  }

  const { id } = match.params
  const product = productStore.products.get(id)

  if (!product) {
    return <Redirect to="/products" />
  }

  function promptDelete() {
    if (window.confirm("Are you sure you want to delete this product")) {
      productStore.deleteProduct(id)
    }
  }

  return (
    <div className="EditProduct">
      <AppHeader>
        <Link to="/products">
          <Icon name="back" color="white" size={12} /> Back to products
        </Link>
        <h1>Edit your product</h1>
      </AppHeader>
      <AppPanel>
        <img className="EditProduct_image" src={product.images[0]} alt="" />
        <div className="EditProduct_info">
          <h3>
            {product.name} ({product.color})
          </h3>
          <p>Full product settings coming soon!</p>
        </div>
        <footer className="EditProduct_actions">
          <Button
            onClick={promptDelete}
            styleName="submit"
            style={{ backgroundColor: "red" }}>
            Delete
          </Button>
          <Link to="/products">Or go back to products</Link>
        </footer>
      </AppPanel>
    </div>
  )
}

export default observer(EditProduct)



// WEBPACK FOOTER //
// ./src/products/edit/EditProduct.js